// extracted by mini-css-extract-plugin
module.exports = {"content":"BannerViewB_content__QovyN"};